export default __webpack_public_path__ + "static/tab01-7b0266e8cac41b23a6c88704d1abfe2d.png";